import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "./i18n";
import { initializeAuthListener } from "./store/authStore.ts";
import { useOrderStore } from "./store/orderStore.ts";
import { useStoreManagementStore } from "./store/storeManagement.ts";
import { initAnalytics } from "./services/analytics";
import { useFeatureFlagStore } from "./store/featureFlagStore.ts";

// Initialize analytics only in production or Capacitor
const shouldInitAnalytics = () => {
  // Check if we're in development mode
  const isDevelopment = import.meta.env.DEV || import.meta.env.MODE === 'development';
  
  // Check if we're in Capacitor (mobile app)
  const isCapacitor = typeof window !== 'undefined' && 'Capacitor' in window;
  
  // Enable analytics in production or Capacitor, disable in development
  const shouldEnable = !isDevelopment || isCapacitor;
  return shouldEnable;
};

if (shouldInitAnalytics()) {
  initAnalytics();
} else {
  console.log('PostHog analytics disabled in development mode');
}

// Initialize the feature flags
const initFeatureFlags = async () => {
  if (shouldInitAnalytics()) {
    // Refresh feature flags after a short delay to ensure PostHog is loaded
    setTimeout(() => {
      useFeatureFlagStore.getState().refreshFlags();
    }, 1000);
  } else {
    console.log('Feature flags disabled in development mode');
  }
};

// Initialize global order subscription system
const initGlobalOrderSystem = async () => {
  try {
    // Initialize the store with available stores, but don't fail if this fails
    await useStoreManagementStore
      .getState()
      .fetchStores()
      .catch((err) => {
        console.warn("Error fetching initial stores:", err);
      });

    // Initialize global subscription only if store is selected
    const orderStore = useOrderStore.getState();
    if (orderStore.selectedStoreId) {
      orderStore.initGlobalSubscription();
    }
  } catch (error) {
    console.error("Error initializing global order system:", error);
  }
};

// Initialize the auth listener to sync with Supabase - do this first
initializeAuthListener();

// Initialize features with a slight delay to ensure auth is initialized
setTimeout(() => {
  // Start the feature flags
  initFeatureFlags();

  // Start the global order system
  initGlobalOrderSystem();
}, 500);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
